import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

export enum UserType {
	Presenter,
	Instructor
}

@Component({
	selector: 'user-type-selection-dialog',
	templateUrl: './user-type-selection-dialog.component.html',
	styleUrls: ['./user-type-selection-dialog.component.scss']
})
export class UserTypeSelectionDialogComponent {

	constructor (private dialogRef: MatDialogRef<UserTypeSelectionDialogComponent>) {}

	public selectInstructor () {
		this.dialogRef.close(UserType.Instructor);
	}

	public selectPresenter () {
		this.dialogRef.close(UserType.Presenter);
	}

	public cancel () {
		this.dialogRef.close();
	}
}
